import { render, staticRenderFns } from "./VideoIntro.vue?vue&type=template&id=1277a22a&scoped=true&"
import script from "./VideoIntro.vue?vue&type=script&lang=js&"
export * from "./VideoIntro.vue?vue&type=script&lang=js&"
import style0 from "./VideoIntro.vue?vue&type=style&index=0&id=1277a22a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1277a22a",
  null
  
)

export default component.exports